export const enClientPortalNotificationSettingsContentPages = {
    settings: {
        notificationSettingsContent: {
            notifications: {
                eMailNotifications: 'Email notifications',
                subtitle: 'When will I receive notifications?',
                appraiserOnly: {
                    message: 'Notification settings for appraisers can currently only be changed in the appraiser software.',
                    action: 'To the appraiser software',
                },
                explanation: {
                    item1: {
                        start: 'By default, you only receive notifications for an order as an ',
                        emphasis: 'assignee or observer',
                        end:
                            '. In that role, you are automatically included in the notification list for all order and task ' +
                            'conversations linked to the order.',
                    },
                    item2: {
                        start: 'Even without that role, you will be notified if you are ',
                        taskEmphasis: 'assigned to a task',
                        middle: ' or on the ',
                        threadEmphasis: 'notification list for a conversation',
                        end: '.',
                    },
                    item3: {
                        start: 'You are ',
                        emphasis: 'not notified about your own changes and messages',
                        end: '.',
                    },
                },
                table: {
                    off: 'OFF',
                    immediate: 'IMMEDIATE EMAIL',
                    batch: 'DAILY DIGEST',
                    batchTooltip: 'If there are updates, you will receive a summary by email up to twice a day.',
                },
            },
        },
    },
}
